import type { RouteConfig } from 'vue-router/types/router';

const routes: RouteConfig[] = [
    {
        path: '/account',
        component: () => import(/* webpackChunkName: "account" */ '@/components/EmptyWrapper.vue'),
        children: [
            {
                path: '',
                name: 'Account',
                component: () => import(/* webpackChunkName: "account" */ '@/views/Account/Settings.vue')
            },
            {
                path: 'integrations',
                name: 'AccountIntegrations',
                component: () => import(/* webpackChunkName: "account" */ '@/views/Account/Integrations.vue')
            },
            {
                path: 'billing',
                name: 'AccountBilling',
                component: () => import(/* webpackChunkName: "account" */ '@/views/Account/Billing.vue')
            },
            {
                path: 'team',
                name: 'AccountTeam',
                component: () => import(/* webpackChunkName: "account" */ '@/views/Account/Team.vue')
            },
            {
                path: 'podBilling',
                name: 'AccountPodBilling',
                component: () => import(/* webpackChunkName: "account" */ '@/views/Account/PodBilling.vue')
            }
        ]
    }
];

export default routes;
